import { render, staticRenderFns } from "./matchResult.vue?vue&type=template&id=01564ad3&scoped=true&"
import script from "./matchResult.vue?vue&type=script&lang=js&"
export * from "./matchResult.vue?vue&type=script&lang=js&"
import style0 from "./matchResult.vue?vue&type=style&index=0&id=01564ad3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01564ad3",
  null
  
)

export default component.exports